export default {
	title: 'settings',
	components: [
		{
			title: 'device_card_customization',
			component: 'customize_device_content',
		},
		{ title: 'channel_name', component: 'channel_name_z' },
		{ title: 'firmware_version', component: 'firmware_update_z' },
		{ title: 'zwave_reboot', component: 'zwave_reboot_z' },
		{ title: 'zwave_reinterview', component: 'zwave_reinterview_z' },
		{ title: 'factory_reset', component: 'factory_reset_z' },
		{ title: 'zwave_remove_failed', component: 'zwave_remove_failed_z' },
		{ title: 'device_information', component: 'device_information' },
	],
};
